"use client";

import React from "react";
import { Header } from "@/components/navigation/Header";
import { Footer } from "@/components/navigation/Footer";
import "react-awesome-slider/dist/styles.css";
import { UserSession } from "@/utils/types";
import { CircularProgress, Fab } from "@mui/material";
import { useSession } from "next-auth/react";
import { useDrawer } from "@/utils/DrawerProvider";
import { useTranslation } from "react-i18next";
import ChatDrawer from "@/app/[locale]/admin/chats/ChatDrawer";
import { PiChatTeardropText } from "react-icons/pi";
import {
  FeaturesSection,
  HomeBannerCard,
  HomeSignUpSeciton,
  HomeVideosSeciton,
  MobileHomeBannerCard,
} from "@/app/[locale]/HomePageComponents";
import { BannersSlider } from "@/app/[locale]/make-to-order/BannerSlider";
import useChatUserID from "@/components/UseChatId";
import { LuPlaneTakeoff } from "react-icons/lu";
import { BiSearch } from "react-icons/bi";
import { IoCarSportOutline } from "react-icons/io5";
import { MdOutlineShoppingCart } from "react-icons/md";

export default function HomePage() {
  const { openDrawer } = useDrawer();
  const session = useSession().data as UserSession;
  const { t } = useTranslation();

  const chatUserID = useChatUserID(session?.id);

  const handleOpenDrawer = () => {
    openDrawer({
      title: t("Chat"),
      content: <ChatDrawer isConflict={0} id={chatUserID} />,
    });
  };

  if (session && !session?.role) {
    return (
      <div className="page grid h100 w100 center">
        <CircularProgress />
      </div>
    );
  }

  return (
    <>
      <Header />
      <div className={"home mp20"}>
        <div className="">
          <br className="mobile-only" />
          <br className="mobile-only" />
          <div className="grid gap30 ">
            <div className=" mobile-only">
              <div className="br20 p30 light-blue-bg c1-auto gap30 vcenter">
                <div>
                  <h2 className="">
                    {t("Hi")} {session?.first_name}{" "}
                  </h2>
                  <p className="">{t("welcome_message")} </p>
                </div>
                <img src="/logo.png" alt="" className="h80px w100" />
              </div>
            </div>
            <BannersSlider isMain={false} />
{/*             <div className=" c1 center bg-grey mobile-only">
              <div className="c2 mc2 gap30 stretch">
                <MobileHomeBannerCard
                  backgroundColor="#16489f"
                  icon={
                    <MdOutlineShoppingCart
                      size={25}
                      className="banner-icon"
                      color="#16489f"
                    />
                  }
                  link="/make-to-order"
                  subtitle="productsSubTitle"
                  title="Découvrez Notre Catalogue"
                />
                <MobileHomeBannerCard
                  backgroundColor="#FFFFFFFF"
                  icon={
                    <LuPlaneTakeoff
                      size={25}
                      className="banner-icon"
                      color="#FFFFFFFF"
                    />
                  }
                  link="/import_china"
                  subtitle="customProductSubTitle"
                  title="specialOrdersAvailable"
                />
                <MobileHomeBannerCard
                  backgroundColor="#FFFFFFFF"
                  icon={<BiSearch size={25} color="#FFFFFFFF" />}
                  link="/sourcing"
                  subtitle="sourcingSubTitle"
                  title="sourcingBigTilte"
                />
                <MobileHomeBannerCard
                  backgroundColor="#16489f"
                  icon={<IoCarSportOutline size={25} color="#16489f" />}
                  link="/cars"
                  subtitle="carsSubTitle"
                  title="discoverOurCars"
                />
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <Space />
      <div className=" home-banners-container c1 center ">
        <div className="c4 mc2 gap50 mgap20 stretch ">
          <HomeBannerCard
            icon={<MdOutlineShoppingCart size={25} className="banner-icon" />}
            link="/make-to-order"
            subtitle="productsSubTitle"
            title="Découvrez Notre Catalogue"
          />
          <HomeBannerCard
            icon={<LuPlaneTakeoff size={25} className="banner-icon" />}
            link="/import_china"
            subtitle="customProductSubTitle"
            title="specialOrdersAvailable"
          />
          <HomeBannerCard
            icon={<BiSearch size={25} className="banner-icon" />}
            link="/sourcing"
            subtitle="sourcingSubTitle"
            title="sourcingBigTilte"
          />
          <HomeBannerCard
            icon={<IoCarSportOutline size={25} className="banner-icon" />}
            link="/cars"
            subtitle="carsSubTitle"
            title="discoverOurCars"
          />
        </div>
      </div>
      <div>
        <Space />
        <HomeVideosSeciton />
      </div>
      <div>
        <Space />
        <FeaturesSection />
      </div>
      <div>
        <Space />
        <HomeSignUpSeciton />
      </div>

      {session?.role !== "admin" && session?.role !== "super-admin" && (
        <Fab
          color="primary"
          className="blue-bg"
          style={{ position: "fixed", bottom: "60px", right: "10px" }}
          size="large"
          onClick={handleOpenDrawer}
        >
          <PiChatTeardropText style={{ width: "20px", height: "20px" }} />
        </Fab>
      )}

      <Footer />
    </>
  );
}

export const Space = () => {
  return (
    <>
      <br />
      <br />
      <br />
    </>
  );
};
